/* @flow */
import { resignAdminship } from 'admin/actions/OrgRoleActions.js';
import AffiliationShape from 'shapes/Affiliation';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import React from 'react';
import Organization from 'entities/Organization';
import ToastActions from 'actions/ToastActions';

class AdminResignModal extends React.Component {
  static propTypes = {
    affiliation: AffiliationShape.isRequired,
    school: React.PropTypes.instanceOf(Organization).isRequired,
    onRequestHide: React.PropTypes.func, // from display modal mixin in ModalTrigger
  };

  resignAsAdmin = () => {
    return resignAdminship(this.props.school.id, CurrentUser.getUserId())
      .then(() =>
        ToastActions.showSuccessToast(
          `You have been remove as administrator of ${this.props.school.getName()}`
        ),
        ToastActions.showDefaultErrorToast
      );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="AdminResignModal"
        title={`Remove yourself as administrator of ${this.props.school.getName()}?`}
        subtext="Once you do, you won’t have access to your school’s staff list,
          staff messaging, and other features for verified administrators."
        actionButtonText="Remove myself as administrator"
        cancelButtonText="Cancel"
        className="AdminResignModal"
        preConfirmPromise={this.resignAsAdmin}
        actionButtonColor="lava"
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}

export default AdminResignModal;



// WEBPACK FOOTER //
// ./src/admin/components/AdminResignModal.jsx